module.exports = __webpack_public_path__ + "static/wareef-scalable-solutions@2x-a71c7edcf6bcd615cb6f097615177ccc.jpg";